module.exports = __webpack_public_path__ + "static/img/1_7.576f6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_7.png
// module id = DrIm
// module chunks = 44